module.exports = __webpack_public_path__ + "static-portal/img/23-1.34971fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/23-1.jpg
// module id = JoCO
// module chunks = 4